// extracted by mini-css-extract-plugin
export default {"container":"kp-z","brandName":"lp-z","productName":"mp-z","productNamePdpEnhancements":"np-z","breakLongProductName":"op-z"};